export default __webpack_public_path__ + "static/media/creatorLandingScreen.48005ca4.jpg";